import menu from '@/config/menu';
import router from '@/router';
import session from './session';
const state =
{
    menuList : [],
    tabList: [],//[{key:'',caption:'',keepAliveComponents:[], routerStack:[]}]  //path history
    currentTab: '',
    customBarName: ''
    //keepAliveComponents: []
};
const getters =
{
    getCurrentTab(state, getters)
    {
        return state.currentTab;
    },
    getCurrentMenuIndex(state, getters)
    {
        return state.currentTab;
    },
    getCurrentBridge(state, getters)
    {
        let index = state.tabList.findIndex((item)=>item.key == state.currentTab);
        if(index > -1)
        {
            let currentTab = state.tabList[index];
            let routerStackLength = currentTab.routerStack.length;
            if(routerStackLength > 1)
            {
                let currentRoute = currentTab.routerStack[routerStackLength - 1];
                return currentRoute.bridge;
            }
        }
        return null;
    },
    getCustomBarName(state, getters)
    {
        return state.customBarName;
    }

};
const actions =
{
    initMenu({commit, state})
    {
        if(state.menuList&&state.menuList.length)
        {
            return;
        }
        console.log('menuList>>',menu.getMenuList());
        let menuList = [];
        for(let menuItem of menu.getMenuList())
        {
            if(menuItem.subMenus && menuItem.subMenus.length)
            {
                let pMenuItem = Fx.mergeDeep(menuItem);
                pMenuItem.subMenus = [];
                for(let subMenuItem of menuItem.subMenus)
                {
                    if(!subMenuItem.permissionGroupId || session.state.userPermissionGroupIdList.indexOf(subMenuItem.permissionGroupId) >= 0)
                    {
                        pMenuItem.subMenus.push(subMenuItem);
                    }
                }
                if(pMenuItem.subMenus.length)
                {
                    menuList.push(pMenuItem);
                }
            }
            else if(!menuItem.permissionGroupId || session.state.userPermissionGroupIdList.indexOf(menuItem.permissionGroupId) >= 0)
            {
                menuList.push(menuItem);
            }
        }
        commit('initMenu', menuList);
    },
    openTab({commit, state}, options)
    {
        //console.log(caption, path, closable);
        commit('openTab', options);
    },
    focusTab({commit, state}, path)
    {
        commit('focusTab', path);
    },
    closeTab({commit, state}, path)
    {
        commit('closeTab', path);
    },
    routeTo({commit, state}, options)
    {
        commit('routeTo', options);
    },
    routeBack({commit, state})
    {
        commit('routeBack');
    },
    setCustomBarName({commit, state}, customBarName)
    {
        commit('setCustomBarName', customBarName);
    }
};
const mutations =
{
    initMenu(state, menuList)
    {
        console.log(menuList);
        state.menuList.splice(0, 0, ...menuList);
    },
    openTab(state, {caption, path, closable=true, bridge})
    {
        console.log('openTab>>>>:', caption, path, closable);

        for(let tab of state.tabList)
        {
            if(tab.key == path)
            {
                state.currentTab = path;
                return;
            }
        }
        let openRoute = router.match(path);
        console.log("openTab openRoute >>>", openRoute);
        state.tabList.push({
            key: path,
            keepAliveComponents:[],
            routerStack: [],
            caption: caption||(openRoute&&openRoute.meta.caption||''),
            closable
        });
        let index = state.tabList.length-1;
        if(openRoute&&openRoute.matched.length)
        {
            let componentName = openRoute.matched[openRoute.matched.length-1].components.default.name;
            state.tabList[index].keepAliveComponents.push(componentName);
            state.tabList[index].routerStack.push({
                path: path,
                component: openRoute.matched[openRoute.matched.length-1].components.default,
                bridge
            });
        }
        state.currentTab = path;
        console.log('after open tab:', path, state);
    },
    routeTo(state, {path, bridge})
    {
        console.log('routeTo:',state, path);
        for(let tab of state.tabList)
        {
            if(tab.key == path)
            {
                state.currentTab = path;
                return;
            }
        }
        let openRoute = router.match(path);
        console.log('openRoute', openRoute, router.getMatchedComponents());
        let index = state.tabList.findIndex((item)=>item.key == state.currentTab);
        if(index > -1 && openRoute && openRoute.matched.length)
        {
            let componentName = openRoute.matched[openRoute.matched.length-1].components.default.name;
            state.tabList[index].keepAliveComponents.push(componentName);
            state.tabList[index].routerStack.push({
                path: path,
                component: openRoute.matched[openRoute.matched.length-1].components.default,
                bridge
            });
        }
        console.log('after routeTo:', path, state);
    },
    routeBack(state)
    {
        console.log("routeBack >>>", state);
        let index = state.tabList.findIndex((item)=>item.key == state.currentTab);
        if(index > -1)
        {
            let currentTab = state.tabList[index];
            let routerStackLength = currentTab.routerStack.length;
            if(routerStackLength > 1)
            {
                let currentRoute = currentTab.routerStack[routerStackLength-1];
                currentRoute.bridge&&currentRoute.bridge.routeBack();
                state.tabList[index].routerStack.splice(state.tabList[index].routerStack.length-1, 1);
                state.tabList[index].keepAliveComponents.splice(state.tabList[index].keepAliveComponents.length-1,1);
                router.replace(state.tabList[index].routerStack[state.tabList[index].routerStack.length-1].path);
            }
            else
            {
                if(routerStackLength)
                {
                    let willCloseTabRouter = currentTab.routerStack[0];
                    willCloseTabRouter.bridge&&willCloseTabRouter.bridge.routeBack();
                }
                state.tabList.splice(index, 1);
                if(state.tabList.length)
                {
                    state.currentTab = state.tabList[index-1].key;
                }
                else
                {
                    state.currentTab = '';
                }
            }
        }
    },
    focusTab(state, path)
    {
        for(let tab of state.tabList)
        {
            if(tab.key == path)
            {
                state.currentTab = path;
                return;
            }
        }
    },
    closeTab(state, path)
    {
        let index = state.tabList.findIndex((item)=>item.key == path);
        if(index>=0)
        {
            state.tabList.splice(index, 1);
            if(path == state.currentTab)
            {
                if(state.tabList.length)
                {
                    state.currentTab = state.tabList[index-1].key;
                }
                else
                {
                    state.currentTab = '';
                }
            }
        }
        console.log('after close tab', state);
    },
    setCustomBarName(state, customBarName)
    {
        state.customBarName = customBarName;
    }
};
export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/layout.js